'use client';

import { useEffect } from 'react';

import { getLogger } from '@/logger/logger';

const BOUNDARY_MESSAGE = 'Unhandled error reached the boundary';

type BoundaryDetails = {
  digest?: string;
  componentStack?: string;
};

export function captureBoundaryError(context: string, error: unknown, details: BoundaryDetails = {}): void {
  getLogger(context).error(BOUNDARY_MESSAGE, {
    error,
    app: {
      event: 'boundary_caught',
      digest: details.digest,
      component_stack: details.componentStack,
    },
  });
}

export function useErrorBoundaryLogger(context: string, error: Error & { digest?: string }): void {
  useEffect(() => {
    captureBoundaryError(context, error, { digest: error.digest });
  }, [context, error]);
}
